<template>
<div class="scrolly-content-svg">
  <div class="svg-wrapper" :index="index">
     <st-get-svg v-if="platform" :class="`st-${platform}-svg`" :rootFolder="rootFolder" :platform="platform" @onGetSvg="onGetSvg"></st-get-svg>
  </div>
</div>
</template>

<script>
import StGetSvg from '../SvgFolder/StGetSvg.vue'

export default {
  props: ['rootFolder', 'index'],
  components: {StGetSvg},
  computed: {
    platform () {
      const {initWidth} = this
      if (!initWidth) return null
      if (initWidth >= 1200) return 'big'
      if (initWidth >= 960) return 'desktop'
      if (initWidth >= 550) return 'tablet'
      return 'mobile'
    }
  },
  data () {
    return {
      initWidth: null,
      screenGroups: []
    }
  },
  mounted () {
    this.initWidth = this.$window.innerWidth
  },
  methods: {
    onGetSvg (svgElem) {
      // TODO
      // this.screenGroups.push(svgElem.querySelectorAll(`g[class*=screen-]`))
    }
  }
}
</script>

<style lang="scss">
@mixin set_scrolly_size($slide_length) {
  [class^="screen-"] {
    transition: opacity 0.5s ease-in;
    opacity: 0;
  }

  @for $i from 0 to $slide_length {
    [index="#{$i}"] .screen-#{$i} {
      transition: opacity 0.5s ease-out;
      opacity: 1;
    }
  }
}

.scrolly-content-svg {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 100%;

  @include set_scrolly_size(20);
}
</style>
